// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".collections-container.padding[data-v-017c2b3c]{padding-bottom:12rem}@media (max-width:767px){.collections-container.padding[data-v-017c2b3c]{padding-bottom:14rem}}", ""]);
// Exports
module.exports = exports;
